import { useState } from "react";
export default function OpenSourceResources() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const links = [{
    title: "Hugging Face",
    description: "Model card, GGUF weights & LoRA adapter — 4,127 downloads last month",
    domain: "huggingface.co ↗"
  }, {
    title: "ternative engine",
    description: "C++17 / CUDA inference engine — source, releases & build instructions",
    domain: "github.com ↗"
  }, {
    title: "orchid-1.0 recipe",
    description: "Training recipe, eval harness & reproduction scripts",
    domain: "github.com ↗"
  }, {
    title: "Zenodo · Technical paper",
    description: "DOI 10.5281/zenodo.20452163 — archived, citable research record",
    domain: "zenodo.org ↗"
  }, {
    title: "FLOSS/fund",
    description: "Support continued open development of Ternative & Orchid",
    domain: "floss.fund ↗"
  }];
  return <section style={{
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(244, 244, 243)",
    fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
    animation: "none 0s ease 0s 1 normal none running",
    backgroundColor: "#0b0b0d"
  }} className="w-full">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500&display=swap');
        .linkrow-title {
          font-size: 1.18rem;
          font-weight: 560;
          letter-spacing: -0.02em;
          color: #f4f4f3;
          transition: color 130ms;
        }
        .linkrow-item:hover .linkrow-title {
          color: #f5c518;
        }
        .linkrow-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          padding: 20px 4px;
          border-bottom: 1px solid rgba(255,255,255,0.09);
          transition: 130ms;
          cursor: pointer;
          text-decoration: none;
        }
      `}</style>
      <div className="md:py-0 py-0" style={{
      paddingTop: "var(--section-pt, 132px)",
      paddingBottom: "var(--section-pb, 132px)"
    }}>
        <style>{`
          @media (max-width: 767px) {
            .open-section-inner {
              --section-pt: 64px;
              --section-pb: 64px;
            }
          }
        `}</style>
        <div className="open-section-inner" style={{
        maxWidth: "1180px",
        marginInline: "auto",
        paddingInline: "clamp(20px, 5vw, 56px)"
      }}>
          <div style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.6em",
          marginBottom: "1.2rem",
          fontFamily: '"JetBrains Mono", "Geist Mono", ui-monospace, "SF Mono", Menlo, monospace',
          fontSize: "0.72rem",
          letterSpacing: "0.22em",
          textTransform: "uppercase",
          color: "#76767d"
        }}>
            <span style={{
            display: "inline-block",
            width: "8px",
            height: "8px",
            backgroundColor: "#f5c518",
            flexShrink: 0
          }} />
            OUT IN THE OPEN
          </div>

          <h2 style={{
          color: "rgb(244, 244, 243)",
          fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
          fontSize: "41.6px",
          fontWeight: "600",
          lineHeight: "43.264px",
          letterSpacing: "-1.248px",
          border: "0px none rgb(244, 244, 243)",
          animation: "none 0s ease 0s 1 normal none running",
          marginBottom: "48px",
          marginTop: "0"
        }}>
            Weights, code, paper, DOI —<br />all public.
          </h2>

          <div>
            {links.map((link, index) => <a key={index} href="#" className="linkrow-item" style={{
            color: "rgb(244, 244, 243)",
            fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
            fontSize: "17px",
            fontWeight: "400",
            lineHeight: "27.2px",
            letterSpacing: "-0.187px",
            padding: "20px 4px",
            animation: "none 0s ease 0s 1 normal none running",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "16px",
            borderBottom: "1px solid rgba(255,255,255,0.09)",
            transition: "130ms"
          }} onMouseEnter={() => setHoveredIndex(index)} onMouseLeave={() => setHoveredIndex(null)}>
                <div style={{
              flex: 1,
              minWidth: 0
            }}>
                  <div className="linkrow-title" style={{
                color: hoveredIndex === index ? "#f5c518" : "#f4f4f3",
                fontSize: "1.18rem",
                fontWeight: "560",
                letterSpacing: "-0.02em",
                transition: "color 130ms",
                lineHeight: "1.4"
              }}>
                    {link.title}
                  </div>
                  <div style={{
                color: "#76767d",
                fontSize: "0.92rem",
                fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
                fontWeight: "400",
                maxWidth: "46ch",
                lineHeight: "1.5",
                marginTop: "2px"
              }}>
                    {link.description}
                  </div>
                </div>
                <div style={{
              fontFamily: '"JetBrains Mono", "Geist Mono", ui-monospace, "SF Mono", Menlo, monospace',
              fontSize: "0.8rem",
              color: "#76767d",
              whiteSpace: "nowrap",
              flexShrink: 0,
              textAlign: "right"
            }}>
                  {link.domain}
                </div>
              </a>)}
          </div>
        </div>
      </div>
    </section>;
}